// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';
import { isValidJson, goToCNTracking } from '../../../../../services/helpers';
import config from '../../../../../configs/envConfig';

export const trackingDashboardActions = {
  GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA',
  GET_CN_TRACKING_DATA_FULL: 'GET_CN_TRACKING_DATA_FULL',
  FILTER_DASHBOARD_DATA: 'FILTER_TRACKING_DASHBOARD_DATA'
};

export const getDashboardDataAction = (load: Object) => ({
  type: trackingDashboardActions.GET_DASHBOARD_DATA,
  payload: load
});

export const filterDashboardData = (load: Object) => ({
  type: trackingDashboardActions.FILTER_DASHBOARD_DATA,
  payload: load
});

export const getCnTrackingDataFullAction = (obj: Object) => ({
  type: trackingDashboardActions.GET_CN_TRACKING_DATA_FULL,
  payload: obj
});

const FailurePayload = (dispatch, res) => {
  dispatch(
    getDashboardDataAction({
      isLoading: false,
      isLoaded: true,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: (res && res.errorMessage) || 'Could not get tracking information'
    })
  );
};

const setLocalStorage = (data, userProfile) => {
  if (!userProfile) {
    return;
  }
  let storage = {};
  if (window.localStorage && window.localStorage.getItem('CONSIGNMENT')) {
    storage = isValidJson(window.localStorage.getItem('CONSIGNMENT'));
  }
  if (!storage[userProfile.user_id]) {
    storage[userProfile.user_id] = [];
  }

  (data || []).forEach(item => {
    const notPresent = storage[userProfile.user_id].every(obj => {
      return obj.cnote !== item.cnote;
    });
    if (notPresent) {
      if (storage[userProfile.user_id].length === 5) {
        storage[userProfile.user_id].pop();
      }
      storage[userProfile.user_id].unshift({
        cnote: item.cnote,
        clientCode: item.clientCode
      });
    }
  });
  window.localStorage.setItem('CONSIGNMENT', JSON.stringify(storage));
};

export const getDashboardData = (
  cnotes: Array<any>,
  urlSearchString: String,
  userProfile: Object
) => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: null
    })
  );

  const data = {
    searchReferenceList: cnotes
  };

  if (urlSearchString) {
    const clientCodeSearch = urlSearchString
      .replace('?', '')
      .split('&')
      .filter(searchString => searchString.indexOf('clientCode') !== -1);
    if (clientCodeSearch && clientCodeSearch.length > 0) {
      data.optionalFiltersMap = {
        clientCode: clientCodeSearch[0].replace('clientCode=', '')
      };
    }
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'trackBulk',
    method: 'POST',
    data,

    successCb: res => {
      if (res.status === 'SUCCESS') {
        setLocalStorage(res.payload, userProfile);
        if (res && res.payload && res.payload.length === 1) {
          // eslint-disable-next-line prefer-destructuring
          const cnote = res.payload[0].cnote;
          goToCNTracking({ cnote }, true);
          return;
        }
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: res.payload,
            dashboardDataFiltered: res.payload,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        FailurePayload(dispatch, res);
      }
    },
    failureCb: res => {
      toastr.error('Error', 'Failed to search results');
      FailurePayload(dispatch, res);
    },
    catchCb: res => {
      toastr.error('Error', 'Failed to search results');
      FailurePayload(dispatch, res);
    }
  };

  return makeApiCall(requestObj);
};
